export const Types = {
    CREATE_STUDY_DRUG_LOG: "CREATE_STUDY_DRUG_LOG",
    LIST_STUDY_DRUG_LOG: "LIST_STUDY_DRUG_LOG"
  };